import { render, staticRenderFns } from "./experimentListElement.vue?vue&type=template&id=b81b7db6&scoped=true"
import script from "./experimentListElement.vue?vue&type=script&lang=js"
export * from "./experimentListElement.vue?vue&type=script&lang=js"
import style0 from "./experimentListElement.vue?vue&type=style&index=0&id=b81b7db6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81b7db6",
  null
  
)

export default component.exports